import React, { useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";

import "chart.js/auto";
import { Chart, CategoryScale } from "chart.js";

Chart.register(CategoryScale);

const BarChart = ({ dados, color, hover, labels }) => {
  const valorItem = dados && dados.map((item, index) => [item]);
  const labelsItem = labels && labels.map((item, index) => item, []);

  const data = {
    labels: labelsItem,
    datasets: [
      {
        label: "Análise de vendas",
        backgroundColor: color,
        borderColor: color,
        borderWidth: 1,
        hoverBackgroundColor: hover,
        hoverBorderColor: hover,
        data: valorItem,
      },
    ],
  };

  const option = {
    scales: {
      dataset: [
        {
          barPercentage: 0.4,
        },
      ],
    },
  };

  return (
    <Bar height={200} data={data} options={{ maintainAspectRatio: false }} />
  );
};

export default BarChart;
